export class MdkTokenRequest {
    public card_number: string = null;
    public card_expire: string = null;
    public security_code: string = null;
    public token_api_key: string = null;
    public lang: string = 'ja';
}